import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEwebinarRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fe7370",
		d: "M4.5 5h16.8c1.6 0 3-.3 3.7 1.5l.3 1.4 1.3 5 .8 2.9-.7.7A17 17 0 0 1 21 20q-1.4.5-3 .5c-.6 0-1.7-.2-2.3-.5q-1.2-.6-1.7-1.9 1.8 0 3.6-.5c2-.6 4.9-2.2 5.1-4.6.6-5.4-7.1-6-10.4-3.6A7 7 0 0 0 9.6 13l-.3 1.4v.8c-.3 1.7 0 3.8 1 5.3q1.4 2.2 4 2.9 1.4.4 2.6.4t2.6-.2l2-.4 2-.8.4-.2 1.4-.7.5-.3 1.5-1.2 1-.7q.1 1 .5 2l.5 2.1q.5 1.3-.3 2.4c-.7 1-1.6.9-2.7.9H10.5q-1.5.1-2.6-.5c-.8-.6-.8-1.5-1.1-2.4l-.6-2.3-.4-1.2-.6-2.5-.4-1.6-1-3.5q0-.8-.3-1.4 0-.6-.3-1l-.7-2.8q0-1 .5-1.7A2 2 0 0 1 4.5 5"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fe7370",
		d: "m16.3 11.2.7.2c.9.5.6 1.7.2 2.5s-1.5 1.4-2.4 1.6l-1 .3v-1c.2-1.4.6-3.4 2.5-3.6"
	})]
});
export default SvgEwebinarRegularIcon;
